import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkPreferences = async () => {
      if (authLoading) return;
      if (!user) { navigate('/'); return; }
      try {
        const { data, error } = await supabase.from('user_preferences').select('id').eq('user_id', user.id).maybeSingle();
        const preAuthPath = sessionStorage.getItem('preAuthPath') || '/';
        sessionStorage.removeItem('preAuthPath');
        if (error) { 
          // Log only in development
          if (process.env.NODE_ENV === 'development') console.error('Error checking preferences:', error); 
          navigate('/'); 
        }
        else if (!data) { 
          // First time user - redirect to preferences
          navigate('/preferences'); 
        }
        else { 
          // Returning user - go to previous path or home
          navigate(preAuthPath === '/auth-callback' ? '/' : preAuthPath); 
        }
      } catch (error) { 
        if (process.env.NODE_ENV === 'development') console.error('Error in auth callback:', error); 
        navigate('/'); 
      } finally { setChecking(false); }
    };
    checkPreferences();
  }, [user, authLoading, navigate]);

  if (checking || authLoading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><div>Loading...</div></div>;
  return null;
};

export default AuthCallback;
